import { GenericRequestBody, GenericResponse } from '@omnea-digital/toolbox'
import createClient from 'openapi-fetch'
import { withErrorCapture } from '@omnea-app/packages/universal/general/observability/withErrorCapture'
import { ServiceUrls } from '@omnea-app/packages/universal/general/serviceUrls'
import { paths } from './risksGeneratedTypes'

interface Params {
  authorization: string
}

export class RisksHttpClient {
  GET
  POST
  constructor({ authorization }: Params) {
    const { GET, POST } = createClient<paths>({
      baseUrl: ServiceUrls.RISKS,
      headers: { Authorization: authorization },
    })
    this.GET = withErrorCapture({ method: GET })
    this.POST = withErrorCapture({ method: POST })
  }
}

export type RiskResponse<T extends keyof paths, T2 extends keyof paths[T]> = GenericResponse<paths, T, T2>
export type RiskRequestBody<T extends keyof paths, T2 extends keyof paths[T]> = GenericRequestBody<paths, T, T2>
